import { clienteSirena } from "./clienteSirena"
import { getSirenaQuotes } from "./getSirenaQuotes"
import { postSirenaQuotes } from "./postSirenaQuotes";
import { putSirenaQuote } from "./putSirenaQuote";
import { getCurrentLead } from "./getCurrentLead"

export const Sirena = {
    clienteSirena,
    getSirenaQuotes,
    postSirenaQuotes,
    putSirenaQuote,
    getCurrentLead
}